import {
  RevokeOtherSessionsResultSchema,
  UserSessionSchema,
  type RevokeOtherSessionsResult,
  type UserSession,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** `/me/sessions` - where the signed-in user is signed in. */

export const listMySessions = async (): Promise<UserSession[]> => {
  const { data } = await apiClient.get<unknown>('/me/sessions');
  return UserSessionSchema.array().parse(data);
};

export const signOutSession = async (id: string): Promise<void> => {
  await apiClient.delete(`/me/sessions/${encodeURIComponent(id)}`);
};

export const signOutOtherSessions = async (): Promise<RevokeOtherSessionsResult> => {
  const { data } = await apiClient.post<unknown>('/me/sessions/revoke-others', {});
  return RevokeOtherSessionsResultSchema.parse(data);
};
